import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../ui/Loader";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import ResolveForm from "../ResolveForm";
import ImageModal from "./ImageModal";
import { discrepancyTabs, truncateText } from "../../PayroleMocks";
import {
  convertStraight,
  formatDateTime,
  getFirstDateOfMonthFromYYYYMM,
} from "../../../common-data/Converts";
import { fetchPayroleDiscrepancyData } from "../../../../redux/payrole-reducers/payroleSlice";

const StaffDiscrepancy = ({
  userInfoData,
  rowData,
  callFunction,
  closeModalPrev,
}) => {
  const dispatch = useDispatch();
  const {
    payroleDiscrepancyData,
    payroleDiscrepancyLoading,
    payroleDiscrepancyError,
  } = useSelector((state) => state.payrole);

  const resolveFormRef = useRef(null);

  const isAdmin = userInfoData?.account_type === "admin";

  const [activeTab, setActiveTab] = useState("pending");
  const iniFilters = {
    user_id: rowData?.user_id || "",
    date: getFirstDateOfMonthFromYYYYMM(rowData?.month_year) || "",
    status: "pending",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);
  const [statsData, setStatsData] = useState({});
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [imageModal, setImageModal] = useState({
    show: false,
    images: [],
    currentIndex: 0,
  });
  const [expandedRemarks, setExpandedRemarks] = useState(new Set());
  const [selectedIds, setSelectedIds] = useState([]);

  const allSelected =
    selectedIds.length === allDatas.allData?.length &&
    allDatas.allData?.length > 0;

  const isRowSelected = (row) => selectedIds.some((r) => r?.uid === row?.uid);

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);

    if (setFilters) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        status: tabKey,
      }));
    }
  };

  const toggleRemarkExpansion = (rowId) => {
    setExpandedRemarks((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(rowId)) {
        newSet.delete(rowId);
      } else {
        newSet.add(rowId);
      }
      return newSet;
    });
  };

  const openImageModal = (images, index = 0) => {
    setImageModal({
      show: true,
      images: images || [],
      currentIndex: index,
    });
  };

  const closeImageModal = () => {
    setImageModal({
      show: false,
      images: [],
      currentIndex: 0,
    });
  };

  const openModal = (discrepancyData) => {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      modName: "resolve-form",
      rowData: discrepancyData,
    }));

    setTimeout(() => {
      if (resolveFormRef.current) {
        resolveFormRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 100);
  };

  const navigateImage = (direction) => {
    const newIndex =
      direction === "next"
        ? (imageModal.currentIndex + 1) % imageModal.images.length
        : (imageModal.currentIndex - 1 + imageModal.images.length) %
          imageModal.images.length;

    setImageModal((prev) => ({
      ...prev,
      currentIndex: newIndex,
    }));
  };

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedIds([]);
    } else {
      setSelectedIds(allDatas.allData ? [...allDatas.allData] : []);
    }
  };

  const handleSelectRow = (id) => {
    const row = allDatas.allData.find((r) => r.uid === id);
    if (!row) return;
    setSelectedIds((prev) => {
      if (prev.some((r) => r.uid === id)) {
        return prev.filter((r) => r.uid !== id);
      } else {
        return [...prev, row];
      }
    });
  };

  const getPayroleDiscrepancy = (filters) => {
    dispatch(
      fetchPayroleDiscrepancyData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    if (filters.user_id || filters.date) {
      getPayroleDiscrepancy(filters);
    }
  }, [filters]);

  useEffect(() => {
    if (
      !payroleDiscrepancyLoading &&
      !payroleDiscrepancyError &&
      payroleDiscrepancyData?.status
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: payroleDiscrepancyData?.data || [],
        pagination:
          payroleDiscrepancyData?.pagination?.length > 0
            ? payroleDiscrepancyData.pagination
            : [],
      }));
      setStatsData(payroleDiscrepancyData?.stats || {});
    } else {
      setAllDatas(iniDatas);
      setStatsData({});
    }
  }, [
    payroleDiscrepancyLoading,
    payroleDiscrepancyError,
    payroleDiscrepancyData,
  ]);

  const columnsPending = [
    {
      dataField: "user_id",
      text: (
        <input
          type="checkbox"
          className="pp-checkbox"
          checked={allSelected}
          onChange={() => handleSelectAll()}
          aria-label="Select all employees"
        />
      ),
      formatter: (_, row) => (
        <input
          type="checkbox"
          className="pp-checkbox"
          checked={isRowSelected(row)}
          onChange={() => handleSelectRow(row?.uid)}
          aria-label={`Select ${row?.name}`}
        />
      ),
    },
    // {
    //   dataField: "user_id",
    //   text: "Employee",
    //   formatter: (_, row) => (
    //     <div className="pp-discrepancy-employee-info">
    //       <p className="pp-discrepancy-employee-name">
    //         {row?.user_name || "NA"}
    //       </p>
    //       <p className="pp-discrepancy-employee-phone">
    //         {row?.user_mobile || ""}
    //       </p>
    //       <p className="pp-discrepancy-employee-phone">
    //         {row?.user_email || ""}
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "date",
      text: "Discrepancy Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "type",
      text: "Type",
      formatter: (_, row) => (
        <span
          className={`pp-discrepancy-type-pill ${
            row.type === "present" ? "pp-status-blue" : "pp-status-green"
          }`}
        >
          {row?.type?.replace(/_/g, " ") || "NA"}
        </span>
      ),
    },
    {
      dataField: "description",
      text: "user remarks",
      formatter: (_, row) => {
        const description = row?.description || "NA";
        const isExpanded = expandedRemarks.has(row.id || row.uid);
        const shouldTruncate = description.length > 50;

        return (
          <div className="pp-discrepancy-description-container">
            <span className="pp-discrepancy-description">
              {isExpanded || !shouldTruncate
                ? description
                : truncateText(description)}
            </span>
            {shouldTruncate && (
              <button
                className="pp-view-more-btn"
                onClick={() => toggleRemarkExpansion(row.id || row.uid)}
              >
                {isExpanded ? "View Less" : "View More"}
              </button>
            )}
          </div>
        );
      },
    },
    {
      dataField: "proof_img",
      text: "images",
      formatter: (_, row) => {
        const images = row?.proof_img;

        if (!images || !Array.isArray(images) || images.length === 0) {
          return <span className="pp-discrepancy-no-images">No Images</span>;
        }

        return (
          <div className="pp-discrepancy-images-container">
            <div className="pp-discrepancy-images-thumbnails">
              {images.slice(0, 3).map((imageUrl, index) => (
                <img
                  key={index}
                  src={imageUrl}
                  alt={`Proof ${index + 1}`}
                  className="pp-discrepancy-image-thumbnail"
                  onClick={() => openImageModal(images, index)}
                />
              ))}
              {images.length > 3 && (
                <div
                  className="pp-discrepancy-images-more"
                  onClick={() => openImageModal(images, 3)}
                >
                  +{images.length - 3}
                </div>
              )}
            </div>
            <span className="pp-discrepancy-images-count">
              {images.length} image{images.length > 1 ? "s" : ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    // {
    //   dataField: "status",
    //   text: "Status",
    //   formatter: (_, row) => (
    //     <span
    //       className={`pp-discrepancy-status-badge ${
    //         row.status === "approved"
    //           ? "pp-status-active"
    //           : row.status === "rejected"
    //           ? "pp-status-inactive"
    //           : "pp-status-pending"
    //       }`}
    //     >
    //       {row?.status?.replace(/_/g, " ")}
    //     </span>
    //   ),
    // },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (_, row) => {
        const isPending = row.status === "pending";
        const isApproved = row.status === "approved";
        const isRejected = row.status === "rejected";

        return (
          <button
            type="button"
            className={`pp-discrepancy-status-badge ${
              isApproved
                ? "pp-status-active"
                : isRejected
                ? "pp-status-inactive"
                : isAdmin && isPending
                ? "pp-status-pending"
                : ""
            }`}
            disabled
          >
            {row?.status?.replace(/_/g, " ") || "NA"}
          </button>
        );
      },
    },
  ];

  const columnsResolved = [
    // {
    //   dataField: "user_id",
    //   text: "Employee",
    //   formatter: (_, row) => (
    //     <div className="pp-discrepancy-employee-info">
    //       <p className="pp-discrepancy-employee-name">
    //         {row?.user_name || "NA"}
    //       </p>
    //       <p className="pp-discrepancy-employee-phone">
    //         {row?.user_mobile || ""}
    //       </p>
    //       <p className="pp-discrepancy-employee-phone">
    //         {row?.user_email || ""}
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "date",
      text: "Discrepancy Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "type",
      text: "Type",
      formatter: (_, row) => (
        <span
          className={`pp-discrepancy-type-pill ${
            row.type === "present" ? "pp-status-blue" : "pp-status-green"
          }`}
        >
          {row?.type?.replace(/_/g, " ") || "NA"}
        </span>
      ),
    },
    {
      dataField: "description",
      text: "user remarks",
      formatter: (_, row) => {
        const description = row?.description || "NA";
        const isExpanded = expandedRemarks.has(row.id || row.uid);
        const shouldTruncate = description.length > 50;

        return (
          <div className="pp-discrepancy-description-container">
            <span className="pp-discrepancy-description">
              {isExpanded || !shouldTruncate
                ? description
                : truncateText(description)}
            </span>
            {shouldTruncate && (
              <button
                className="pp-view-more-btn"
                onClick={() => toggleRemarkExpansion(row.id || row.uid)}
              >
                {isExpanded ? "View Less" : "View More"}
              </button>
            )}
          </div>
        );
      },
    },
    {
      dataField: "proof_img",
      text: "images",
      formatter: (_, row) => {
        const images = row?.proof_img;

        if (!images || !Array.isArray(images) || images.length === 0) {
          return <span className="pp-discrepancy-no-images">No Images</span>;
        }

        return (
          <div className="pp-discrepancy-images-container">
            <div className="pp-discrepancy-images-thumbnails">
              {images.slice(0, 3).map((imageUrl, index) => (
                <img
                  key={index}
                  src={imageUrl}
                  alt={`Proof ${index + 1}`}
                  className="pp-discrepancy-image-thumbnail"
                  onClick={() => openImageModal(images, index)}
                />
              ))}
              {images.length > 3 && (
                <div
                  className="pp-discrepancy-images-more"
                  onClick={() => openImageModal(images, 3)}
                >
                  +{images.length - 3}
                </div>
              )}
            </div>
            <span className="pp-discrepancy-images-count">
              {images.length} image{images.length > 1 ? "s" : ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "approved_by",
      text: "approved by",
      formatter: (_, row) => (
        <div className="pp-discrepancy-employee-info">
          <p className="pp-discrepancy-employee-name">
            {row.approved_by || "NA"}
          </p>
          <p className="pp-discrepancy-employee-phone">
            {row.approved_by_mobile || ""}
          </p>
          <p className="pp-discrepancy-employee-phone">
            {row.approved_by_email || ""}
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "status",
    //   text: "Status",
    //   formatter: (_, row) => (
    //     <span
    //       className={`pp-discrepancy-status-badge ${
    //         row.status === "approved"
    //           ? "pp-status-active"
    //           : row.status === "rejected"
    //           ? "pp-status-inactive"
    //           : "pp-status-pending"
    //       }`}
    //     >
    //       {row?.status?.replace(/_/g, " ")}
    //     </span>
    //   ),
    // },
    // {
    //   dataField: "actions",
    //   text: "Actions",
    //   formatter: (_, row) => {
    //     return (
    //       <button
    //         type="button"
    //         className="pp-employee-payroll-action-button pp-dark-badge"
    //         onClick={() =>
    //           setModValues((prevs) => ({
    //             ...prevs,
    //             isModOpen: true,
    //             modName: "regenerate-form",
    //             rowData: row,
    //           }))
    //         }
    //       >
    //         Regenerate
    //       </button>
    //     );
    //   },
    // },
  ];

  const columnsRejected = [
    // {
    //   dataField: "user_id",
    //   text: "Employee",
    //   formatter: (_, row) => (
    //     <div className="pp-discrepancy-employee-info">
    //       <p className="pp-discrepancy-employee-name">
    //         {row?.user_name || "NA"}
    //       </p>
    //       <p className="pp-discrepancy-employee-phone">
    //         {row?.user_mobile || ""}
    //       </p>
    //       <p className="pp-discrepancy-employee-phone">
    //         {row?.user_email || ""}
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "date",
      text: "Discrepancy Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "type",
      text: "Type",
      formatter: (_, row) => (
        <span
          className={`pp-discrepancy-type-pill ${
            row.type === "present" ? "pp-status-blue" : "pp-status-green"
          }`}
        >
          {row?.type?.replace(/_/g, " ") || "NA"}
        </span>
      ),
    },
    {
      dataField: "description",
      text: "user remarks",
      formatter: (_, row) => {
        const description = row?.description || "NA";
        const isExpanded = expandedRemarks.has(row.id || row.uid);
        const shouldTruncate = description.length > 50;

        return (
          <div className="pp-discrepancy-description-container">
            <span className="pp-discrepancy-description">
              {isExpanded || !shouldTruncate
                ? description
                : truncateText(description)}
            </span>
            {shouldTruncate && (
              <button
                className="pp-view-more-btn"
                onClick={() => toggleRemarkExpansion(row.id || row.uid)}
              >
                {isExpanded ? "View Less" : "View More"}
              </button>
            )}
          </div>
        );
      },
    },
    {
      dataField: "proof_img",
      text: "images",
      formatter: (_, row) => {
        const images = row?.proof_img;

        if (!images || !Array.isArray(images) || images.length === 0) {
          return <span className="pp-discrepancy-no-images">No Images</span>;
        }

        return (
          <div className="pp-discrepancy-images-container">
            <div className="pp-discrepancy-images-thumbnails">
              {images.slice(0, 3).map((imageUrl, index) => (
                <img
                  key={index}
                  src={imageUrl}
                  alt={`Proof ${index + 1}`}
                  className="pp-discrepancy-image-thumbnail"
                  onClick={() => openImageModal(images, index)}
                />
              ))}
              {images.length > 3 && (
                <div
                  className="pp-discrepancy-images-more"
                  onClick={() => openImageModal(images, 3)}
                >
                  +{images.length - 3}
                </div>
              )}
            </div>
            <span className="pp-discrepancy-images-count">
              {images.length} image{images.length > 1 ? "s" : ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "approved_by",
      text: "approved by",
      formatter: (_, row) => (
        <div className="pp-discrepancy-employee-info">
          <p className="pp-discrepancy-employee-name">
            {row.approved_by || "NA"}
          </p>
          <p className="pp-discrepancy-employee-phone">
            {row.approved_by_mobile || ""}
          </p>
          <p className="pp-discrepancy-employee-phone">
            {row.approved_by_email || ""}
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "status",
    //   text: "Status",
    //   formatter: (_, row) => (
    //     <span
    //       className={`pp-discrepancy-status-badge ${
    //         row.status === "approved"
    //           ? "pp-status-active"
    //           : row.status === "rejected"
    //           ? "pp-status-inactive"
    //           : "pp-status-pending"
    //       }`}
    //     >
    //       {row?.status?.replace(/_/g, " ")}
    //     </span>
    //   ),
    // },
    // {
    //   dataField: "actions",
    //   text: "Actions",
    //   formatter: (_, row) => {
    //     return <span className="tb-data text-green">salary Processed</span>;
    //   },
    // },
  ];

  return (
    <div className="pp-modal-overlay" onClick={closeModalPrev}>
      <div
        className="pp-modal-container pp-gym-details-modal mod-width-70p mod-height-95vh"
        onClick={(e) => e.stopPropagation()}
        style={{ padding: "30px" }}
      >
        <div className="pp-modal-header">
          <div className="pp-modal-header-left">
            <button
              className="pp-back-btn"
              onClick={closeModalPrev}
              aria-label="Back to overview"
            >
              ← Back to Overview
            </button>
            <div className="pp-modal-title-section">
              <h1 className="pp-modal-title">
                {rowData?.user_name || "Staff Details"}
              </h1>
              <p className="pp-modal-subtitle lowercase">
                {rowData?.user_mobile || ""} · {rowData?.user_email || ""}
              </p>
            </div>
          </div>
          <button
            className="pp-close-btn pp-btn-outline"
            onClick={closeModalPrev}
            aria-label="Close modal"
          >
            Close
          </button>
        </div>

        <div className="pp-discrepancy-tabs">
          {discrepancyTabs.map((tab) => (
            <button
              key={tab.key}
              className={`pp-discrepancy-tab-item ${
                activeTab === tab.key ? "pp-discrepancy-tab-active" : ""
              }`}
              onClick={() => handleTabChange(tab.key)}
            >
              {tab.label} (
              {tab.key === "rejected"
                ? statsData?.rejected_count || 0
                : tab.key === "approved"
                ? statsData?.approved_count || 0
                : statsData?.pending_count || 0}
              )
            </button>
          ))}
        </div>

        {(selectedIds.length > 0 || modValues.isModOpen) && (
          <div className="pp-selected-staff-info">
            <button
              type="button"
              className="pp-btn-process"
              onClick={openModal}
            >
              {selectedIds.length} Staff Selected -{" "}
              <span>Click to resolve discrepancy</span>
            </button>
          </div>
        )}

        <div className="pp-employee-payroll-table-wrapper">
          {payroleDiscrepancyLoading ? (
            <Loader />
          ) : (
            <PaymentLinkTable
              tableData={allDatas.allData}
              tableColumns={
                activeTab === "pending"
                  ? columnsPending
                  : activeTab === "approved"
                  ? columnsResolved
                  : columnsRejected
              }
              //   tablePagination={allDatas.pagination}
              // isPage={isPage}
              // setIsPage={(value) => setIsPage(value)}
              // pageLimit={pageLimit}
              // setPageLimit={setPageLimit}
            />
          )}
        </div>

        {modValues.isModOpen && modValues.modName === "resolve-form" && (
          <ResolveForm
            userInfoData={userInfoData}
            resolveFormRef={resolveFormRef}
            selectedRows={selectedIds}
            allRows={allDatas.allData}
            callFunction={() => {
              callFunction();
              getPayroleDiscrepancy(filters);
            }}
            closeModal={() => {
              closeModal();
              closeModalPrev();
            }}
            rowData={rowData}
          />
        )}

        {/* <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={closeModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          <ResolveForm
            userInfoData={userInfoData}
            resolveFormRef={resolveFormRef}
            selectedRows={selectedIds}
            allRows={allDatas.allData}
            callFunction={() => {
              callFunction();
              getPayroleDiscrepancy(filters);
            }}
            closeModal={closeModal}
          />
        </Modal> */}

        {imageModal.show && (
          <ImageModal
            closeImageModal={closeImageModal}
            navigateImage={navigateImage}
            imageModal={imageModal}
            setImageModal={setImageModal}
          />
        )}
      </div>
    </div>
  );
};

export default StaffDiscrepancy;
